import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { UserProvider } from "./globals/UserContext";
import { HtmlProvider } from "./globals/HtmlContext";
import { TeacherProvider } from "./globals/TeacherContext";
import { AnswerProvider } from "./globals/AnswerContext";
import { QuestionProvider } from "./globals/QuestionContext";
import { AssignmentProvider } from "./globals/AssignmentContext";
import { AssignmentReviewProvider } from "./globals/AssignmentReviewContext";
import { createTheme, ThemeProvider } from "@mui/material";
import { ClassProvider } from "./globals/ClassContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
//We can make changes to theme that will apply globally. For example
//I just threw in a random color as our primary color and you can
//see how if you change that the main color of our app will change everywhere.
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2b2d42",
      light: "rgba(43, 45, 66, 0.3)",
      green: "rgba(20, 200, 40, 1)"
    },
    secondary: {
      main: "#d90429",
    },
    background: {
      main: "#edf2f4",
    },
    gray: {
      main: "#8d99ae",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AssignmentReviewProvider>
          <UserProvider>
            <HtmlProvider>
              <ClassProvider>
                <TeacherProvider>
                  <AnswerProvider>
                    <QuestionProvider>
                      <AssignmentProvider>
                        <App />
                      </AssignmentProvider>
                    </QuestionProvider>
                  </AnswerProvider>
                </TeacherProvider>
              </ClassProvider>
            </HtmlProvider>
          </UserProvider>
        </AssignmentReviewProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>
);
